module.exports = __webpack_public_path__ + "img/seguranca_publica.76546b6a.png";